/**
 * @namespace {BX.Main.Popup}
 */
const CloseIconSize = Object.freeze({
	LARGE: 'large',
	SMALL: 'small',
})

export default CloseIconSize;